// extracted by mini-css-extract-plugin
export default {"content":"PageCarousel_content__45Xmu","circle-inactive":"PageCarousel_circle-inactive__OO7Yd","circle-active":"PageCarousel_circle-active__YpQAz"};